import { ViewController } from 'elc-service';
import { action, computed } from 'mobx';
import { ComponentTypes } from '../constants/ComponentTypes';
import {
    IProductAutoReplenish,
    IProductAutoReplenishOptions
} from '../views/product-auto-replenish/ProductAutoReplenish';

export interface IAutoReplenishmentControllerConfig {
    autoReplenishment: IProductAutoReplenishOptions;
}

export class ProductAutoReplenishmentViewController extends ViewController {
    private componentType: ComponentTypes;
    private config: IAutoReplenishmentControllerConfig;

    @action
    public initialize = (props: IProductAutoReplenish) => {
        const { componentType, config } = props;
        this.componentType = componentType;
        this.config = config as IAutoReplenishmentControllerConfig;
    };

    @computed
    public get componentConfig() {
        const { overrides, ...autoReplenishmentConfig } = this.config.autoReplenishment;

        const configOverrides = overrides && overrides[this.componentType];

        return { ...autoReplenishmentConfig, ...configOverrides };
    }

    @computed
    public get data() {
        return {
            componentConfig: this.componentConfig
        };
    }

    @computed
    public get intervals() {
        return this.config.autoReplenishment.intervals || [];
    }

    @computed
    public get toggleType() {
        return this.config.autoReplenishment.toggleType;
    }

    @computed
    public get infoModalConfig() {
        return {
            infoPopupTriggerType: this.config.autoReplenishment.infoPopupTriggerType,
            infoPopupNodeId: this.config.autoReplenishment.infoPopupNodeId
        };
    }
}
